<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <KTCodePreview v-bind:title="'Alumni Siswa'">
                    <template v-slot:body>
                        <v-row class="mb-4">
                            <v-col cols="12" md="12">
                                <!-- <selectTahun></selectTahun> -->
                                <!-- <v-row>
                                    <v-col cols="12" md="2">
                                        <span>Pilih Angkatan</span>
                                    </v-col>
                                    <v-col cols="12" md="10">
                                        <SelectComponent :data="angkatan" :changeSelected="changeAngkatan" width="70%"
                                            Title="" :models="selectedAngkatan"></SelectComponent>
                                    </v-col>
                                </v-row> -->
                            </v-col>
                                <CardBukuWisudawan :data="dataCard"></CardBukuWisudawan>
                        </v-row>
                    </template>
                </KTCodePreview>
            </div>
        </div>
    </div>
</template>

<style scoped>
textarea {
    resize: none;
    height: 150px;
}

.colorBlue {
    background-color: #3751E4;
}
</style>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
// import selectTahun from '@/view/content/components/select/SelectTahun.vue';
// import selectAngkatan from '@/view/content/components/select/SelectAngkatan.vue';
// import SelectComponent from "@/view/content/components/select/SelectComponent.vue";
import axios from 'axios';
// import ButtonComponent from '@/view/content/components/button/buttonComponent.vue';
import CardBukuWisudawan from '@/view/content/components/card/CardBukuWisudawan.vue';

export default {
    data() {
        return {
            dataCard: [],
        };
    },
    components: {
        KTCodePreview,
        // selectTahun,
        // selectAngkatan
        // SelectComponent,
        // ButtonComponent,
        CardBukuWisudawan
    },
    async mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Buku Wisudawan sssss" },
        ]);
        this.getdata();
    },
    methods: {
        async getdata() {
            await axios.get('/portal-alumni/buku-wisudawan')
                .then(response => {
                    if (response.status == 200) {
                        response.data.data.some((e, index) => {
                            if(e.file != null && e.thumbnail != null){
                                var object = { 
                                    key:index+1,
                                    tahun: e.tahun, 
                                    tahun_akhir: e.tahun_akhir, 
                                    thumbnail: this.$endpoint + 'uploads/buku_wisudawan/' + e.thumbnail, 
                                    file:e.file 
                                }
                            // var object = { "id": e.key, "text": e.tahun + " " + e.semester }
                                this.dataCard.push(object);
                            }
                            
                            return index > e.length;
                        });
                    }
                })
        },
        async getGeneration() {
            await axios.get('master/generations')
                .then(response => {
                    if (response.status == 200) {
                        response.data.data.some((e, index) => {
                            var object = { "id": e.key, "text": e.tahun + " / " + e.tahun_akhir + " " + e.semester }
                            // var object = { "id": e.key, "text": e.tahun + " " + e.semester }
                            this.angkatan.push(object);
                            return index > e.length;
                        });
                    }
                })
        },
        changeAngkatan: async function (selected) {            
            this.selectedAngkatan = selected;
            
            this.selectedAngkatan = selected;
            const result = await axios.get(`portal-alumni/alumni-filter/${selected}`);
            if (this.code4.desserts.length > 0) {
                this.code4.desserts = []
            }
            result.data.data.map((filter, index) => {
                let obj = {
                    no: index + 1,
                    key: filter.key,
                    nrp: filter.nrp,
                    nama: filter.name,
                    angkatan: filter.generation_name,
                };
                this.code4.desserts.push(obj);
            });
        },
    }
}
</script>